import React from 'react';
import { Icon } from './Icon';

const ViewsIcon = ({ size }: Props) => {
  return (
    <Icon type="eye" color="bg-label-primary-purple" size={size} />
  );
}

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export { ViewsIcon };